/**
 * Default currency code used across the application as a fallback
 * when no specific currency is configured.
 */
export const DEFAULT_CURRENCY_CODE = 'USD';
